import { render, staticRenderFns } from "./dossier-medical.html?vue&type=template&id=c1615188&scoped=true&external"
import script from "./dossier-medical.js?vue&type=script&lang=js&external"
export * from "./dossier-medical.js?vue&type=script&lang=js&external"
import style0 from "./dossier-medical.scss?vue&type=style&index=0&id=c1615188&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1615188",
  null
  
)

export default component.exports